import script from "./AgencyMgmt.vue?vue&type=script&setup=true&lang=js"
export * from "./AgencyMgmt.vue?vue&type=script&setup=true&lang=js"

import "./AgencyMgmt.vue?vue&type=style&index=0&id=1ffe1530&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_mcn_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ffe1530"]])

export default __exports__